import { useCallback } from 'react';
import { useSupplierOfferDeleteMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const { handleError, handleSuccess } = useNotificationMessages();

  const [supplierOfferDelete, { isLoading }] = useSupplierOfferDeleteMutation();

  const onRemoveConfirm = useCallback(
    async (recordId: string | undefined) => {
      if (recordId) {
        try {
          const { data, error } = await supplierOfferDelete(recordId);
          if (data?.success) {
            handleSuccess('Supplier Offer was successfully deleted.');
            onDeleteModalClose();
          } else {
            handleError(error);
          }
        } catch (err) {
          handleError(err);
        }
      }
    },
    [handleSuccess, onDeleteModalClose, handleError, supplierOfferDelete]
  );

  return {
    onRemoveConfirm,
    isLoading,
  };
};
